import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'rmt-dashboard-card',
  templateUrl: 'rmt-dashboard-card.html'
})
export class RmtDashboardCardComponent {
  @Input() title: string;
  @Input() titleButton: string;
  @Input() header: string;
  @Input() edit: boolean = false;
  @Input() showHeaderButton: boolean = false;
  @Input() headerButtonText: string;
  @Input() headerButtonTheme: string;
  @Input() headerButtonIcon: string;
  @Output() titleButtonClick = new EventEmitter<any>();  
  @Output() onEdit = new EventEmitter<any>();  
  @Output() onHeaderButtonClick = new EventEmitter<any>();  

  constructor() {
  }

  clickTitleButton() {
    this.titleButtonClick.emit();
  }

  clickEdit() {
    this.onEdit.emit();
  }

  clickHeaderButton() {
    this.onHeaderButtonClick.emit();
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-dashboard-card/rmt-dashboard-card.ts